/**
 * Zod schemas for annotation time module extension.
 */
import { z } from "zod"

export const annotationTimeConfigSchema = z.object({
  type: z.literal("annotation_time")
})

const unsupportedAnnotationPayloadSchema = z.object({}).superRefine((_value, ctx) => {
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: "annotation_time does not support annotation create/update payloads"
  })
})

export const createAnnotationTimeSchema = unsupportedAnnotationPayloadSchema
export const updateAnnotationTimeSchema = unsupportedAnnotationPayloadSchema
